export const INTERNAL_DOMAINS = [
  'business-dev.oyindonesia.com',
  'business.oyindonesia.com',
  'm-business-dev.oyindonesia.com',
  'm-business.oyindonesia.com',
  'desktop-business-dev.oyindonesia.com',
  'desktop-business.oyindonesia.com',
];
